import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AttendancePage from './pages/AttendancePage';
import TableAssignmentPage from './pages/TableAssignmentPage';
import AdminPage from './pages/AdminPage';
import { useAttendanceStore } from './stores/attendanceStore';

function App() {
  const { loadTableSettings } = useAttendanceStore();

  useEffect(() => {
    // 앱 시작 시 저장된 테이블 설정 로드
    loadTableSettings();
  }, [loadTableSettings]);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/attendance" element={<AttendancePage />} />
          <Route path="/table-assignment" element={<TableAssignmentPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
